import { logEvent } from '@/analytics';
import { useGetData, useSetData } from '@/common/data';
import Toast from '@/components/Toast';
import { checkIsMobile } from '@/utils/device';
import { restoreChatVisibility } from './Chat.script';

const DATA_KEY = 'chat';

export type ChatData = {
  isEnabled: boolean;
  isReady: boolean;
  isError: boolean;
  isVisible: boolean;
  totalUnread: number;
};

export const useSetChatData = () => useSetData(DATA_KEY);

export const useChatData = () => {
  const {
    isEnabled = false,
    isReady = false,
    isError = false,
    isVisible = false,
    totalUnread = 0,
  } = useGetData(DATA_KEY) || {};
  return {
    isEnabled,
    isReady,
    isError,
    isLoading: isEnabled && !isReady && !isError,
    isVisible,
    totalUnread,
    toggleVisibility: () => {
      if (isError) {
        return Toast.open({ variant: 'error', children: 'خطایی رخ داده است.' });
      }
      if (!isEnabled || !isReady) return;
      restoreChatVisibility();
      logEvent('CHAT', {
        reference: document.title,
        platform: checkIsMobile() ? 'MOBILE' : 'WEB',
      });
    },
  };
};
